import * as React from 'react'

export const SvgAccountOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" aria-hidden={true} {...props}>
    <path d="M12 14c4.97 0 9 3.134 9 7h-2c0-2.636-3.04-5-7-5s-7 2.364-7 5H3c0-3.866 4.03-7 9-7zm0-10.998a4.749 4.749 0 110 9.498 4.749 4.749 0 010-9.498zm0 1.9a2.85 2.85 0 100 5.698 2.85 2.85 0 000-5.698z" />
  </svg>
)
export default SvgAccountOutline
